let cartTrigger;
document.addEventListener('DOMContentLoaded', function () {
    cartTrigger = document.querySelector('.wiacc-show-cartlayer');

    if (cartTrigger) {
        cartTrigger.addEventListener('click', function () {
            const delay = parseInt(this.getAttribute('data-timer')) || 400;
            const targetClass = this.getAttribute('data-target');
            setTimeout(() => {
                disableScroll();
                handleEscapeClose();
                handleFocusTrap(cartTrigger, targetClass);
            }, delay);
        });
    }
});
